/*
 * Copyright (c) 2024 GM Global Technology Operations LLC. All rights reserved.
 * This information is confidential and proprietary to GM Global Technology
 * Operations LLC and may not be used, modified, copied or distributed.
 */

import BookmarkBorderIcon from "@mui/icons-material/BookmarkBorder";
import React from "react";
import BookmarkIcon from "@mui/icons-material/Bookmark";
import {styled} from "@mui/material/styles";

const StyledBookmarkIcon = styled(BookmarkIcon)({
  cursor: 'pointer'
})

const ArgosFavoriteIcon = (props: any) => {
  return (
    <StyledBookmarkIcon fontSize={'large'} color={'warning'} {...props}/>
  )
}

const StyledBookmarkBorderIcon = styled(BookmarkBorderIcon)({
  cursor: 'pointer'
})

const ArgosFavoriteBorderIcon = (props: any) => {
  return (
    <StyledBookmarkBorderIcon fontSize={'large'} color={'warning'} {...props}/>
  )
}

export {ArgosFavoriteIcon, ArgosFavoriteBorderIcon}